export const settingsActionTypes = {
    SETTINGS_REQUESTED: 'SETTINGS_REQUESTED',
    SETTINGS_RECEIVED: 'SETTINGS_RECEIVED',
    SETTINGS_UPDATE_REQUESTED: 'SETTINGS_UPDATE_REQUESTED',
    SETTINGS_UPDATE_SUCCESSFUL: 'SETTINGS_UPDATE_SUCCESSFUL',
    SETTINGS_REQUEST_FAILED: 'SETTINGS_REQUEST_FAILED',
    SETTINGS_UPDATE_FAILED: 'SETTINGS_UPDATE_FAILED',
    WEBCONFIG_RECEIVED: 'WEBCONFIG_RECEIVED'
};

//TODO: Get rid of this and move it to the actual action
export const settingsUris = {
    getSettingsUri: `${process.env.REACT_APP_MYACCOUNT_URL}/config/getInitialConfig`, 
    updateSettingsUri: `${process.env.REACT_APP_MYACCOUNT_URL}/customerProfile/customerAttributes`
};




// WEBPACK FOOTER //
// ./src/settings/actions/settings-action-types.js